import { z } from "zod";

import { API_TYPES } from "../api";

// eslint-disable-next-line no-restricted-syntax
export enum AgreementKind {
  INDEPENDENT_CONTRACTOR = "independent-contractor",
  JOB_SEARCH = "job-search",
}

export const AGREEMENT_KIND_LABELS: Record<AgreementKind, string> = {
  [AgreementKind.INDEPENDENT_CONTRACTOR]: "IC Agreement",
  [AgreementKind.JOB_SEARCH]: "Job Search Agreement",
};

const agreementAttributesSchema = z.object({
  downloadUrl: z.string().url().nullish(),
  kind: z.nativeEnum(AgreementKind),
  version: z.number(),
});

const signedAgreementAttributesSchema = agreementAttributesSchema.extend({
  signedAt: z.string().datetime(),
});

export const signedAgreementSchema = z.object({
  type: z.literal(API_TYPES.signedAgreement),
  id: z.string(),
  attributes: signedAgreementAttributesSchema,
});

export const signedAgreementsResponseSchema = z.object({
  data: z.array(signedAgreementSchema),
});

export const signedAgreementsRequestSchema = z.object({
  kind: z.array(z.nativeEnum(AgreementKind)).optional(),
  /**
   * If omitted, will return all versions
   */
  version: z.number().optional(),
});

export type SignedAgreementsResponse = z.infer<typeof signedAgreementsResponseSchema>;
export type SignedAgreement = z.infer<typeof signedAgreementSchema>;
export type SignedAgreementsRequestQuery = z.infer<typeof signedAgreementsRequestSchema>;
